module.exports = __webpack_public_path__ + "static/media/houses.d4478f63.svg";